import React, { useEffect, useState } from 'react';
import 'Assets/styles/default/pages/concierge/ManageConciergeSolicitationStyles.less';
import { Col, Row } from 'antd';
import { Typography } from '@vertem-core/vertice-ds'
import PropTypes from 'prop-types';
import { formatCEP, formatDocument } from 'Utils/format';

const ManageConciergeAddress = ({ ...props }) => {

    const {
        addresses
    } = props;

    const [deliveryAddress, setDeliveryAddress] = useState();
    const [billingAddress, setBillingAddress] = useState();

    useEffect(() => {
        if (addresses.length > 0) {
            setBillingAddress(addresses.find(addr => addr.billingAddress)?.billingAddress);
            setDeliveryAddress(addresses.find(addr => addr.deliveryAddress)?.deliveryAddress);
        }
    }, [addresses])

    return (
        <>
            <Row>
                <Col md={24} lg={18}>
                    <div className='margin-top-small'>
                        <Typography.Text className='details-card-title'>
                            Endereços
                        </Typography.Text>
                    </div>
                    <div className='container-addresses-main'>
                        <Row gutter={[8, { xs: 16, sm: 16 }]} className='container-addresses-sub'>
                            <Col sm={24} md={12}>
                                <div className='container-address-billing'>
                                    <Typography.Text className='details-card-title'>
                                        Endereço de faturamento
                                    </Typography.Text>
                                    {
                                        billingAddress ?
                                            <>
                                                <div className='margin-top-extra-small'>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        Nome:
                                                    </Typography.Text>
                                                    <Typography.Text >
                                                        {billingAddress.name}
                                                    </Typography.Text>
                                                </div>
                                                <div>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        Documento:
                                                    </Typography.Text>
                                                    <Typography.Text >
                                                        {formatDocument(billingAddress.document)}
                                                    </Typography.Text>
                                                </div>
                                                <div>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        CEP:
                                                    </Typography.Text>
                                                    <Typography.Text>
                                                        {formatCEP(billingAddress.zipCode)}
                                                    </Typography.Text>
                                                </div>
                                                <div>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        Endereço:
                                                    </Typography.Text>
                                                    <Typography.Text>
                                                        {`${billingAddress.address}, ${billingAddress.number} ${billingAddress?.complement ?? ''}`}
                                                    </Typography.Text>
                                                </div>
                                                <div>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        Bairro:
                                                    </Typography.Text>
                                                    <Typography.Text>
                                                        {billingAddress.district}
                                                    </Typography.Text>
                                                </div>
                                                <div>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        Cidade:
                                                    </Typography.Text>
                                                    <Typography.Text>
                                                        {`${billingAddress.city} - ${billingAddress.state}`}
                                                    </Typography.Text>
                                                </div>
                                            </>
                                            :
                                            <>
                                                Nenhum endereço informado.
                                            </>
                                    }
                                </div>
                            </Col>
                            <Col sm={24} md={12}>
                                <div className='container-address-shipping'>
                                    <Typography.Text className='details-card-title'>
                                        Endereço de entrega
                                    </Typography.Text>
                                    {
                                        deliveryAddress ?
                                            <>
                                                <div className='margin-top-extra-small'>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        Nome:
                                                    </Typography.Text>
                                                    <Typography.Text >
                                                        {deliveryAddress.name}
                                                    </Typography.Text>
                                                </div>
                                                <div>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        Documento:
                                                    </Typography.Text>
                                                    <Typography.Text >
                                                        {formatDocument(deliveryAddress.document)}
                                                    </Typography.Text>
                                                </div>
                                                <div>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        CEP:
                                                    </Typography.Text>
                                                    <Typography.Text>
                                                        {formatCEP(deliveryAddress.zipCode)}
                                                    </Typography.Text>
                                                </div>
                                                <div>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        Endereço:
                                                    </Typography.Text>
                                                    <Typography.Text>
                                                        {`${deliveryAddress.address}, ${deliveryAddress.number} ${deliveryAddress?.complement ?? ''}`}
                                                    </Typography.Text>
                                                </div>
                                                <div>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        Bairro:
                                                    </Typography.Text>
                                                    <Typography.Text>
                                                        {deliveryAddress.district}
                                                    </Typography.Text>
                                                </div>
                                                <div>
                                                    <Typography.Text className='margin-right-extra-small' strong>
                                                        Cidade:
                                                    </Typography.Text>
                                                    <Typography.Text>
                                                        {`${deliveryAddress.city} - ${deliveryAddress.state}`}
                                                    </Typography.Text>
                                                </div>
                                            </>
                                            :
                                            <>
                                                Nenhum endereço informado.
                                            </>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </>
    )
}

ManageConciergeAddress.propTypes = {
    addresses: PropTypes.object.isRequired
};

export default ManageConciergeAddress;